export interface FlowBaseCheckboxCreateRequestImpl {
  idInscriptionFlow: number;
  name: string;
  description: string;
  tooltip: string;
  visible?: boolean;
  enabled?: boolean;
  required?: boolean;
}

export class FlowBaseCheckboxCreateRequestImpl {
  constructor(idInscriptionFlow: number) {
    this.idInscriptionFlow = idInscriptionFlow;
  }

  idInscriptionFlow: number;
  name = "Nouvelle checkbox";
  description = "";
  tooltip = "";
  visible?: boolean = true;
  enabled?: boolean = true;
  required?: boolean = false;
}
